import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "cross",
  "use": "cross-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" id=\"cross\"><path d=\"M22.66 24L12 13.21 1.86 23.34l-1.2-1.2L10.8 12 .13 1.2 1.34 0 12 10.79 22.14.66l1.2 1.2L13.2 12l10.68 10.8-1.22 1.2z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol